<template>
    <div
        :class="{ [`l-ss-c-filter-enum-${filter.name}`]: true, 'l-ss-c-filter-is-short': isShort }"
        class="l-ss-c-filter-enum">
        <c-label
            v-if="showTitle"
            :label="filterLabel"/>
        <span
            v-if="showSearchField && hasSearchField"
            class="l-ss-c-filter-enum-search-wrap">
            <app-input
                v-model="localSearch"
                class="l-ss-c-filter-enum-search-input"
                :placeholder="$t('filters.enumSearch')"/>
        </span>
        <div
            class="l-ss-c-filter-enum-group-wrapper"
            :class="{
                'l-ss-c-filter-enum-group-wrapper-full': showMore,
                'l-ss-c-filter-enum-group-wrapper-is-tag-checkboxes': true,
            }">
            <template v-for="(option, index) in filterOptionsSort">
                <tag-checkbox
                    v-if="isShortCurrentFilterView"
                    :key="`filter-tag-checkbox-${option.id}`"
                    :value="isChecked(option.id)"
                    :class="{ 'l-ss-c-filter-enum-option-primary': isPrimaryOption(option.id) }"
                    @change="onToggle($event, option, index)">
                    <span v-html="transformValue(option.name)"></span>
                </tag-checkbox>

                <app-checkbox
                    v-else
                    :key="`filter-checkbox-${option.id}`"
                    :value="isChecked(option.id)"
                    class="l-ss-c-filter-enum-option"
                    :class="{ 'l-ss-c-filter-enum-option-primary': isPrimaryOption(option.id) }"
                    @change="onToggle($event, option, index)">
                    <span v-html="transformValue(option.name)"></span>
                </app-checkbox>
            </template>
        </div>
        <show-more-btn
            v-if="hasShowMore"
            class="l-ss-c-navigation-list-item-action"
            @click="emitChangeSize"
            v-model="showMore"/>
    </div>
</template>

<script>
    import FilterMixin, { MIN_ITEMS_COUNT_FOR_SHOW_MORE, MIN_ITEMS_COUNT_FOR_SEARCH_FIELD } from './mixin';
    import CLabel from './components/label';
    import AppInput from '@/core/components/common/app-input.vue';
    import AppCheckbox from '@/core/components/common/app-checkbox.vue';
    import TagCheckbox from '@/core/components/common/tag-checkbox.vue';
    import ShowMoreBtn from '@/core/components/show-more-btn.vue';

    export default {
        components: {
            ShowMoreBtn,
            AppCheckbox,
            TagCheckbox,
            AppInput,
            CLabel,
        },
        mixins: [
            FilterMixin,
        ],
        props: {},
        data() {
            return {
                values: [],
                trackParams: [],
            };
        },
        computed: {
            filterOptions() {
                let options = this.filter.options;

                if (this.localSearch) {
                    const localSearch = this.localSearch.trim().toLowerCase();
                    options = options.filter(item => item.name.toLowerCase().includes(localSearch));
                }

                return options;
            },

            filterOptionsSort() {
                /**
                 * Сортирует массив фильтров в соответствии с их выборкой.
                 * @param {Array} options - массив опций фильтра
                 * @returns {Array} отсортированный массив опций фильтра
                 */
                const sortActiveOnTop = (options) => {
                    const selectedIndexMap = new Map(this.values.map((id, index) => [id, index]));

                    return options.sort((a, b) => {
                        let indexA = selectedIndexMap.get(a.id);
                        let indexB = selectedIndexMap.get(b.id);

                        if (indexA === undefined) {
                            indexA = Infinity;
                        }

                        if (indexB === undefined) {
                            indexB = Infinity;
                        }

                        return indexA - indexB;
                    });
                };

                let options = this.values.length ? sortActiveOnTop(this.filterOptions) : this.filterOptions;

                if (!this.showMore) {
                    options = options.slice(0, MIN_ITEMS_COUNT_FOR_SEARCH_FIELD);
                }

                return options;
            },

            optionsIndex() {
                return this.filter.options.slice(0).map(item => ({
                    ...item,
                    searchIndex: item.name.toLowerCase(),
                    firstLetter: item.name.charAt(0).toLowerCase(),
                }));
            },

            showSearchField() {
                return this.localSearch || this.optionsIndex.length > MIN_ITEMS_COUNT_FOR_SEARCH_FIELD;
            },

            hasShowMore() {
                if (this.forceShowAll) {
                    return false;
                }

                return this.filter.options.length > MIN_ITEMS_COUNT_FOR_SHOW_MORE + 1;
            },

            filterId() {
                return this.filter?.id || '';
            },

            filterConfig() {
                return this.$configuration.filterConfig || {};
            },

            currentFilterConfig() {
                return this.filterConfig[this.filterId] || null;
            },

            isShortCurrentFilterView() {
                if (this.currentFilterConfig?.isShort === false) {
                    return false;
                }

                if (this.currentFilterConfig?.isShort) {
                    return true;
                }

                return this.$configuration.isShortFilterView;
            },

            hasSearchField() {
                return this.currentFilterConfig?.hasSearch !== false;
            },
        },
        watch: {
            filterValue: {
                handler(value) {
                    if (value && value.options) {
                        this.values = value.options.slice(0);
                        this.values = Array.from(new Set(this.values));
                    } else {
                        this.values = [];
                    }
                },
                immediate: true,
            },
            filterOptionsSort(value, oldValue) {
                if (value.length !== oldValue.length) {
                    this.$nextTick(() => {
                        this.$emit('change-size');
                    });
                }
            },
        },
        created() {
            if (this.forceShowAll) {
                this.showMore = true;
            }
        },
        mounted() {
            const options = this.options || [];
            if (this.values.length && !this.values.every(optionId => options.find(item => item.id === optionId))) {
                this.showMore = true;
            }
        },
        methods: {
            isChecked(optionId) {
                return this.values.includes(optionId);
            },
            onToggle(eventData, option, index) {
                const checked = this.isChecked(option.id);
                const values = this.values.slice(0);
                if (checked) {
                    values.splice(values.indexOf(option.id), 1);
                    this.trackParams.splice(this.trackParams.indexOf(option.id), 1);
                } else {
                    values.push(option.id);

                    const trackValue = {
                        ...option,
                        pos: index + 1,
                    };

                    this.trackParams.push(trackValue);
                }
                if (values.length) {
                    this.onChange({
                        condition: 'in',
                        options: values.slice(0),
                    });

                    this.onFilterClick(eventData.event, this.trackParams);
                } else {
                    this.onChange();
                    this.onFilterClick(eventData.event);
                }
            },
            isPrimaryOption(optionId) {
                const primaryOptions = this.$configuration.primaryFilterOptions[this.filter.name];
                return primaryOptions && primaryOptions.includes(optionId);
            },
        },
    };
</script>
